



















































































































import User from '@/domain/user'
import mobileTypeMixin from '@/global/mobile/mobileTypeMixin'
import mixins from 'vue-typed-mixins'
import usersMixin from './usersMixin'
import { RoleEnum } from '@/domain/role'
import Openable from '@/global/viewmodels/openable'

export default mixins(usersMixin, mobileTypeMixin).extend({
    components: {
        DialogUser: () => import('./components/DialogUser.vue'),
    },
    data() {
        return {
            typeRoleClient: RoleEnum.Client,
            typeRoleCommercial: RoleEnum.Commercial,
            dialogUser: new Openable(),
            userSelected: new User(),
            page: 1,
            pageCount: 0,
            chipUserStyle: {
                // C'est une méthode que j'utilise pour binder des props directement sur un element vue et d'eviter de recoder les memes props x fois pour un element similaire
            },
        }
    },
    methods: {
        nomPrenom(user: User): string {
            return user.prenom + ' ' + user.nom.toUpperCase()
        },
        editUser(user = new User()) {
            this.userSelected = user
            this.dialogUser.open()
        },
        getColor(role: RoleEnum) {
            switch (role) {
                case RoleEnum.SuperAdmin:
                    return 'purple'
                case RoleEnum.CoDir:
                    return 'blue'
                case RoleEnum.Commercial:
                    return 'green'
                case RoleEnum.Client:
                    return 'red'
                case RoleEnum.ADV:
                    return 'orange'
                default:
                    return 'yellow'
            }
        },
        itemRowBackground(item: User): string {
            return item.desactive ? 'row-disabled' : ''
        },
        onChangeRole() {
            if (!this.userSelected) return

            this.userSelected.permissions = this.rolesParDefaut[this.userSelected.roleEnum]
        },
        getHeaders() {
            return this.isMobileDevice()
                ? [
                      { text: 'Nom', value: 'nomComplet', width: '25%' },
                      { text: 'Role', value: 'role', width: '25%' },
                  ]
                : [
                      { text: 'Id', value: 'id', width: '5%' },
                      { text: 'Nom', value: 'nomComplet', width: '20%', align: 'center' },
                      { text: 'Email', value: 'email', width: '20%', align: 'start' },
                      { text: 'Role', value: 'role' },
                      { text: '', value: 'actions', align: 'end', sortable: false },
                  ]
        },
        onClientChanged() {
            if (this.userSelected && this.userSelected.codeClientBiobank) {
                this.userSelected.domTom = !/^[0-9][0-9].*$/.test(this.userSelected?.codeClientBiobank.substr(0, 2))
                this.userSelected.dentaire = this.userSelected.codeClientBiobank.substr(2, 1) == '1'
                this.userSelected.ortho = this.userSelected.codeClientBiobank.substr(2, 1) == '0'
            }
        },
    },
})
